import { HttpParams } from '@angular/common/http';

export function openInNewTab(
  url: string,
  queryParams?: Record<string, string | number | boolean>,
  features?: string
): Window {
  const query = queryParams ? `?${new HttpParams().appendAll(queryParams).toString()}` : '';
  return window.open(url + query, '_blank', features);
}
